import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  Game,
  LastFive,
  Ranks,
  Rest,
  RosterList,
  ScorePronos,
  ScoringPosition,
  Standings,
  StandingsOldModel,
  Streak,
  TeamStats,
  TopPlayersDay
} from 'src/app/models/games/games.models';

@Injectable()
export class StatsService implements OnInit {
  game = new BehaviorSubject<Game[]>(this.getLocalGameList());
  roadStatsTrigger = new EventEmitter()
  homeStatsTrigger = new EventEmitter()
  lastCount = 6


  // tslint:disable-next-line: contextual-lifecycle
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) {}

  getScheduleByDate(date: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      gameDay: date,
    });
    return this.http
      .get<Game[]>('/api/schedule/date', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getTeamStats(team: string, date: string ) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay: date
    });
    return this.http
      .get<TeamStats>(`/api/stats/team`, { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getScoring(gameId: number ) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      gameId,
    });
    
    return this.http
      .get<ScorePronos>(`/api/schedule/date/difficulty`, { headers })
      .pipe(catchError(this.scoringErrorHandler));
  }
  
  getScoringPosition(team: string ) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
    });
    
    return this.http
      .get<ScoringPosition>(`/api/stats/scoring/position`, { headers })
      .pipe(catchError(this.scoringPositionErrorHandler));
  }

  getRanks(team: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
    });
    return this.http
      .get<Ranks>('/api/stats/ranks', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getLastFive(team: string, date: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay: date
    });
    return this.http
      .get<LastFive>('/api/schedule/date/last', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getLastFiveHomeRoad(team: string, date: string, location: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay: date,
      location
    });
    return this.http
      .get<LastFive>('/api/schedule/date/lastHomeRoad', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getLastOppositionGame(homeTeam: string, roadTeam: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      homeTeam,
      roadTeam,
    });
    return this.http
      .get<LastFive>('/api/schedule/date/against', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getStandingsOld(team: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
    });
    return this.http
      .get<StandingsOldModel[]>('/api/stats/standings', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getStandings(team: string, gameDay: string, allSeason : string = "false") {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay,
      lastGames: this.lastCount,
      allSeason
    });
    return this.http
      .get<Standings>('/api/stats/standings', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getRest(team: string, date: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay: date
    });
    return this.http
      .get<Rest>('/api/schedule/date/rest', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getStreak(team: string, date: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
      gameDay: date
    });
    return this.http
      .get<Streak>('/api/schedule/date/streak', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getRosterHomeList(team: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
    });
    return this.http
      .get<RosterList>('/api/stats/roster/home', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  
  getRosterRoadList(team: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      team,
    });
    return this.http
      .get<RosterList>('/api/stats/roster/road', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getTopPlayers(gameDay: string) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json',
      gameDay,
    });
    return this.http
      .get<TopPlayersDay>('/api/stats/roster/top', { headers })
      .pipe(catchError(this.scheduledErrorHandler));
  }

  getAvgRealWinnersCombo(matchCount: number, start?: string, end?: string) {
    let params: any = { matchCount };
    if (start) params.start = start;
    if (end) params.end = end;

    return this.http
      .get<any>('/api/stats/odds/avg-real-combo', { params })
      .pipe(catchError(this.scheduledErrorHandler));
  }
  getGameList(date: string) {
    const gameList = this.getScheduleByDate(date);
    return gameList;
  }

  getLocalGameList(): Game[] {
    return JSON.parse(localStorage.getItem('gameList'));
  }


  getCurrentGameList(): Observable<Game[]> {
    return this.game.asObservable();
  }

  getCorrectName(teamName: string) {
    if (teamName === "Los Angeles Clippers") {
      // return "Los Angeles Clippers";
      return "LA Clippers";
    } else if (teamName === "Philadelphia 76Ers") {
      return "Philadelphia 76ers";
    } else {
      return teamName;
    }
  }

  private scheduledErrorHandler(httpErrorResponse: HttpErrorResponse) {
    if (httpErrorResponse.status === 400) {
      console.error('Error: ', httpErrorResponse.error.message);
    } else {
      console.error('Backend error: ', httpErrorResponse.error);
    }
    // window.alert('Erreur lors de la récuperation des match');
    return throwError('Une erreur s\'est produite');
  }
  
  private scoringPositionErrorHandler(httpErrorResponse: HttpErrorResponse) {
    if (httpErrorResponse.status === 400) {
      console.error('Error: ', httpErrorResponse.error.message);
    } else {
      console.error('Backend error: ', httpErrorResponse.error);
    }
    // window.alert('Erreur lors de la récuperation des match');
    return throwError('Une erreur s\'est produite');
  }
  
  private scoringErrorHandler(httpErrorResponse: HttpErrorResponse) {
    if (httpErrorResponse.status === 400) {
      console.error('Error: scoringErrorHandler');
      console.error('Error: ', httpErrorResponse.error.message);
    } else {
      console.error('Error: scoringErrorHandler');
      console.error('Backend error: ', httpErrorResponse.error);
    }
    // window.alert('Erreur lors de la récuperation des match');
    return throwError('Une erreur s\'est produite');
  }


}
